import PropTypes from 'prop-types';

export const currencyMask = (value) => {
  if (typeof value !== 'number') {
    return value;
  }

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(value);
};
currencyMask.propTypes = {
  number: PropTypes.number,
};
